<template>
  <SideBarAsideFix/>

  <div class="content pd-0" style="border: 1px solid #ccc;">
    <div class="content-header">
      <div class="content-search">
        <i data-feather="search"></i>
        <input type="search" class="form-control" placeholder="Search...">
      </div>
      <nav class="nav">
        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
        <a href="" class="nav-link"><i data-feather="grid"></i></a>
        <a href="" class="nav-link"><i data-feather="align-left"></i></a>
      </nav>
    </div><!-- content-header -->

    <div class="content-body">


      <div class="sms-send-component">
        <!-- Content Header -->
        <div class="content-header">
          <div class="content-search">
            <i data-feather="search"></i>
            <input type="search" class="form-control" placeholder="Search…">
          </div>
          <nav class="nav">
            <a href="#" class="nav-link"><i data-feather="help-circle"></i></a>
            <a href="#" class="nav-link" style="position:relative">
              <i data-feather="bell"></i>
              <span class="badge badge-danger"
                    style="position:absolute;top:6px;right:6px;width:7px;height:7px;padding:0;border-radius:50%;"></span>
            </a>
            <a href="#" class="nav-link">
              <img
                  src="https://ui-avatars.com/api/?name=Katherine+Pechon&size=32&background=0168fa&color=fff&rounded=true"
                  alt="user" class="wd-32 rounded-circle">
            </a>
          </nav>
        </div>

        <div class="content-body">
          <!-- Breadcrumb + title -->
          <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25">
            <div>
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                  <li class="breadcrumb-item"><a href="#">SMS</a></li>
                  <li class="breadcrumb-item active" aria-current="page">Send Message</li>
                </ol>
              </nav>
              <h4 class="mg-b-0 tx-spacing--1">Send SMS</h4>
            </div>
            <div class="d-none d-md-flex align-items-center" style="gap:8px;">
              <div class="d-flex align-items-center pd-x-12 pd-y-6 rounded" style="background:#eef3ff;gap:6px;">
                <i class="fas fa-coins" style="color:#0168fa;font-size:13px;"></i>
                <span class="tx-13 tx-semibold" style="color:#0168fa;"><span>{{ balance }}</span> credits</span>
              </div>
              <a href="sms-buy-credits.html" class="btn btn-sm btn-white btn-upper btn-bold">
                <i data-feather="plus" class="wd-10 mg-r-5"></i> Buy Credits
              </a>
            </div>
          </div>

          <!-- Low balance warning -->
          <div class="credit-warning mg-b-20" :class="{ show: balance < 50 }">
            <i class="fas fa-exclamation-triangle" style="font-size:15px;flex-shrink:0;"></i>
            <div>
              <strong>Low balance — <span>{{ balance }}</span> credits remaining.</strong>
              You can send approximately <span>{{ Math.floor(balance / Math.max(1, messageSegments)) }}</span> more
              messages.
              <a href="sms-buy-credits.html" class="tx-semibold"
                 style="color:#92400e;text-decoration:underline;margin-left:4px;">Buy credits →</a>
            </div>
          </div>

          <!-- STEPPER -->
          <div class="stepper-wrap">
            <div class="stepper">
              <div
                  v-for="(step, index) in steps"
                  :key="index"
                  class="step-tab"
                  :class="{
              active: currentStep === step.num,
              done: currentStep > step.num,
              disabled: currentStep < step.num - 1
            }"
                  @click="jumpTo(step.num)"
              >
                <div class="step-num">
                  <i v-if="currentStep > step.num" class="fas fa-check" style="font-size:10px;"></i>
                  <span v-else>{{ step.num }}</span>
                </div>
                <div class="step-text">
                  <div class="step-title-text">{{ step.title }}</div>
                  <div class="step-subtitle">{{ step.subtitle }}</div>
                </div>
              </div>
            </div>
            <div class="stepper-progress">
              <div class="stepper-progress-fill" :style="{ width: progressPercent }"></div>
            </div>
          </div>

          <!-- TWO-COLUMN LAYOUT -->
          <div class="row">
            <!-- LEFT: Step panels -->
            <div class="col-xl-8 col-lg-7">
              <!-- PANEL 1: Recipients -->
              <div class="step-panel" v-show="currentStep === 1">
                <div class="card">
                  <div class="card-header pd-t-20 pd-b-20">
                    <div>
                      <h6 class="card-title">Recipients</h6>
                      <p class="card-text">Type or paste phone numbers, or pick from your CRM contacts.</p>
                    </div>
                    <div class="card-option">
                      <span class="tx-13 tx-color-03">{{
                          recipients.length
                        }} recipient{{ recipients.length !== 1 ? 's' : '' }}</span>
                    </div>
                  </div>
                  <div class="card-body pd-20">
                    <!-- Source toggle tabs -->
                    <ul class="nav nav-tabs recip-tabs mg-b-16" style="border-bottom:none;">
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: recipientTab === 'manual' }" href="#"
                           @click.prevent="recipientTab = 'manual'">
                          <i class="fas fa-keyboard mg-r-5" style="font-size:12px;"></i> Type Numbers
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: recipientTab === 'crm' }" href="#"
                           @click.prevent="recipientTab = 'crm'">
                          <i class="fas fa-address-book mg-r-5" style="font-size:12px;"></i> CRM Contacts
                        </a>
                      </li>
                    </ul>

                    <!-- Manual number entry -->
                    <div v-show="recipientTab === 'manual'">
                      <div class="recipient-box" @click="focusRecipientInput">
                    <span v-for="(recipient, idx) in recipients" :key="idx" class="recipient-tag">
                      {{ recipient }}
                      <button class="tag-remove" type="button" @click="removeTag(idx)">&#x2715;</button>
                    </span>
                        <input
                            ref="recipientInput"
                            type="text"
                            v-model="newRecipient"
                            placeholder="e.g. +447700900001 — press Enter or comma to add…"
                            @keydown="handleTagKey"
                            @input="recipientInputHint"
                        >
                      </div>
                      <p class="tx-12 tx-color-03 mg-t-6 mg-b-0">
                        <i class="fas fa-info-circle mg-r-4"></i>
                        Use E.164 format (+447700…). Separate with comma or press Enter.
                      </p>
                    </div>

                    <!-- CRM contact picker -->
                    <div v-show="recipientTab === 'crm'">
                      <div class="input-group mg-b-12">
                        <div class="input-group-prepend">
                          <span class="input-group-text"><i data-feather="search"
                                                            style="width:14px;height:14px;"></i></span>
                        </div>
                        <input type="text" class="form-control" placeholder="Search contacts by name or number…"
                               v-model="contactSearch">
                      </div>
                      <div id="contactList" style="max-height:240px;overflow-y:auto;">
                        <div
                            v-for="contact in filteredContacts"
                            :key="contact.phone"
                            class="contact-row"
                            @click="toggleCrmContact(contact.phone)"
                        >
                          <div class="contact-avatar" :style="{ background: contact.color }">{{
                              contact.initials
                            }}
                          </div>
                          <div style="flex:1;">
                            <div class="tx-13 tx-semibold tx-color-01">{{ contact.name }}</div>
                            <div class="tx-12 tx-color-03">{{ contact.phone }}</div>
                          </div>
                          <div><input type="checkbox" class="form-check-input" :checked="crmSelected.has(contact.phone)"
                                      style="pointer-events:none;"></div>
                        </div>
                        <p v-if="filteredContacts.length === 0" class="tx-13 tx-color-03 pd-y-10">No contacts found.</p>
                      </div>
                      <div class="mg-t-10 d-flex align-items-center justify-content-between">
                        <span class="tx-13 tx-color-03">{{ crmSelected.size }} selected</span>
                        <button class="btn btn-sm btn-primary" @click="addCrmSelected">
                          Add Selected <i class="fas fa-arrow-right mg-l-5" style="font-size:11px;"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer d-flex align-items-center justify-content-between pd-x-20 pd-y-14"
                       style="background:#f8f9fc;">
                    <span class="tx-12 tx-color-03">Add at least one recipient to continue.</span>
                    <button class="btn btn-primary btn-sm" @click="goNext(1)">
                      Next: Message <i class="fas fa-arrow-right mg-l-6" style="font-size:11px;"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- PANEL 2: Message -->
              <div class="step-panel" v-show="currentStep === 2">
                <div class="card">
                  <div class="card-header pd-t-20 pd-b-20">
                    <div>
                      <h6 class="card-title">Message</h6>
                      <p class="card-text">Compose your SMS. Use merge tags to personalise each message.</p>
                    </div>
                    <div class="card-option">
                      <div class="d-flex align-items-center" style="gap:8px;">
                        <span class="tx-12 tx-color-03">{{ messageSegments }} segment{{
                            messageSegments !== 1 ? 's' : ''
                          }}</span>
                        <div class="seg-dots">
                          <div v-for="i in 3" :key="i" class="seg-dot" :class="{ active: i <= messageSegments }"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body pd-20">
                    <div class="row row-sm mg-b-15">
                      <div class="col-md-6">
                        <label class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-5">
                          Sender ID <small class="tx-normal tx-color-04">(optional)</small>
                        </label>
                        <input type="text" class="form-control" v-model="senderId" placeholder="AcmeCRM" maxlength="11">
                        <span class="tx-12 tx-color-03 d-block mg-t-4">Max 11 alphanumeric characters.</span>
                      </div>
                      <div class="col-md-6">
                        <label
                            class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-5">Encoding</label>
                        <select class="form-control" v-model="encoding">
                          <option value="gsm7">GSM-7 (Standard) — 160 chars / segment</option>
                          <option value="ucs2">Unicode (Emoji / non-Latin) — 70 chars / segment</option>
                        </select>
                      </div>
                    </div>

                    <label class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-5">
                      Message Body <span style="color:#ef4444;">*</span>
                    </label>
                    <div class="msg-area-wrap" style="position:relative;">
                      <textarea ref="messageTextarea" class="form-control" rows="5" v-model="messageBody"
                                placeholder="Hi {{firstName}}, your message here…"></textarea>
                      <div class="msg-footer-bar">
                        <div class="char-meter">
                          <div class="bar-track">
                            <div class="bar-fill"
                                 :class="{ warn: charPercent >= 80 && charPercent < 100, over: charPercent >= 100 }"
                                 :style="{ width: charPercent + '%' }"></div>
                          </div>
                          <span class="tx-12 tx-color-03">{{ messageLength }} / {{ maxCharsPerSegment }}</span>
                          <span class="tx-12 tx-color-03">·</span>
                          <span class="tx-12 tx-semibold" style="color:#0168fa;">{{
                              messageSegments
                            }} msg{{ messageSegments !== 1 ? 's' : '' }}</span>
                        </div>
                        <div style="position:relative;">
                          <button class="btn btn-xs btn-white merge-btn" type="button" @click="toggleMergeDropdown"
                                  style="font-size:11px;padding:3px 9px;">
                            <i class="fas fa-code mg-r-4" style="font-size:10px;"></i> Merge Tag
                          </button>
                          <div class="merge-dropdown" :class="{ open: mergeDropdownOpen }">
                            <div class="merge-head">Contact Fields</div>
                            <div class="merge-item" @click="insertMerge('{{firstName}}')">{{ firstName }}</div>
                            <div class="merge-item" @click="insertMerge('{{lastName}}')">{{ lastName }}</div>
                            <div class="merge-item" @click="insertMerge('{{company}}')">{{ company }}</div>
                            <div class="merge-head">Booking Fields</div>
                            <div class="merge-item" @click="insertMerge('{{appointmentDate}}')">{{
                                appointmentDate
                              }}
                            </div>
                            <div class="merge-item" @click="insertMerge('{{bookingRef}}')">{{ bookingRef }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="alert alert-warning d-flex align-items-center pd-y-10 pd-x-12 mg-t-10 mg-b-0"
                         style="font-size:13px;" v-if="hasUnicode && encoding === 'gsm7'">
                      <i class="fas fa-exclamation-triangle mg-r-8" style="flex-shrink:0;font-size:14px;"></i>
                      Your message contains Unicode characters. Segment limit is 70 characters. Consider switching to
                      Unicode encoding above.
                    </div>
                  </div>
                  <div class="card-footer d-flex align-items-center justify-content-between pd-x-20 pd-y-14"
                       style="background:#f8f9fc;">
                    <button class="btn btn-white btn-sm" @click="goPrev(2)">
                      <i class="fas fa-arrow-left mg-r-6" style="font-size:11px;"></i> Back
                    </button>
                    <button class="btn btn-primary btn-sm" @click="goNext(2)">
                      Next: Send Time <i class="fas fa-arrow-right mg-l-6" style="font-size:11px;"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- PANEL 3: Send Time -->
              <div class="step-panel" v-show="currentStep === 3">
                <div class="card">
                  <div class="card-header pd-t-20 pd-b-20">
                    <div>
                      <h6 class="card-title">Send Time</h6>
                      <p class="card-text">Dispatch immediately or schedule for a specific date and time.</p>
                    </div>
                    <div class="card-option"><span class="badge badge-primary tx-11">Final step</span></div>
                  </div>
                  <div class="card-body pd-20">
                    <ul class="nav nav-tabs send-mode-tabs mg-b-20" style="border-bottom:1px solid #e5e9f2;">
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: !isSchedule }" href="#"
                           @click.prevent="isSchedule = false">
                          <i class="fas fa-paper-plane mg-r-5" style="font-size:12px;"></i> Send Now
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: isSchedule }" href="#" @click.prevent="isSchedule = true">
                          <i class="fas fa-clock mg-r-5" style="font-size:12px;"></i> Schedule for Later
                        </a>
                      </li>
                    </ul>

                    <div v-show="!isSchedule">
                      <div class="alert alert-light d-flex align-items-center pd-y-10 pd-x-12 mg-b-0"
                           style="font-size:13px;border:1px solid #e5e9f2;">
                        <i class="fas fa-bolt mg-r-10" style="color:#0168fa;flex-shrink:0;font-size:16px;"></i>
                        <div>
                          <strong>Messages will be dispatched immediately after confirmation.</strong><br>
                          <span class="tx-color-03">Delivery typically takes 3–10 seconds per recipient.</span>
                        </div>
                      </div>
                    </div>

                    <div v-show="isSchedule">
                      <div class="row row-sm mg-b-15">
                        <div class="col-sm-5">
                          <label class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-5">
                            Date <span style="color:#ef4444;">*</span>
                          </label>
                          <input type="text" class="form-control" v-model="schedDate" placeholder="Select date…">
                        </div>
                        <div class="col-sm-3">
                          <label class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-5">
                            Time <span style="color:#ef4444;">*</span>
                          </label>
                          <input type="text" class="form-control" v-model="schedTime" placeholder="09:00" maxlength="5"
                                 @input="formatTime">
                        </div>
                        <div class="col-sm-4">
                          <label
                              class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-5">Timezone</label>
                          <select class="form-control" v-model="schedTz">
                            <option>Europe/London (GMT+1)</option>
                            <option>Europe/Paris (GMT+2)</option>
                            <option>America/New_York (GMT-4)</option>
                            <option>America/Los_Angeles (GMT-7)</option>
                            <option>Asia/Dubai (GMT+4)</option>
                          </select>
                        </div>
                      </div>
                      <div class="alert alert-info d-flex align-items-center pd-y-9 pd-x-12 mg-b-0"
                           style="font-size:13px;">
                        <i class="fas fa-info-circle mg-r-8" style="flex-shrink:0;font-size:14px;"></i>
                        Credits will be debited immediately when the scheduled time is reached and sending begins.
                      </div>
                    </div>

                    <!-- Send summary -->
                    <div class="mg-t-20 pd-t-20" style="border-top:1px solid #f0f2f7;">
                      <div class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-12">Message
                        Summary
                      </div>
                      <table class="w-100" style="font-size:13px;">
                        <tr>
                          <td style="color:#8392a5;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;width:130px;padding:7px 0;border-top:1px solid #f0f2f7;">
                            Recipients
                          </td>
                          <td style="font-weight:500;color:#1c273c;padding:7px 0;border-top:1px solid #f0f2f7;">
                            {{ recipients.length }} recipient{{ recipients.length !== 1 ? 's' : '' }}
                          </td>
                        </tr>
                        <tr>
                          <td style="color:#8392a5;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;padding:7px 0;border-top:1px solid #f0f2f7;">
                            Sender ID
                          </td>
                          <td style="font-weight:500;color:#1c273c;padding:7px 0;border-top:1px solid #f0f2f7;">
                            {{ senderId || 'AcmeCRM' }}
                          </td>
                        </tr>
                        <tr>
                          <td style="color:#8392a5;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;padding:7px 0;border-top:1px solid #f0f2f7;">
                            Message
                          </td>
                          <td style="font-weight:500;color:#1c273c;padding:7px 0;border-top:1px solid #f0f2f7;max-width:340px;white-space:pre-wrap;word-break:break-word;">
                            {{ messageBody || '—' }}
                          </td>
                        </tr>
                        <tr>
                          <td style="color:#8392a5;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;padding:7px 0;border-top:1px solid #f0f2f7;">
                            Segments/msg
                          </td>
                          <td style="font-weight:500;color:#1c273c;padding:7px 0;border-top:1px solid #f0f2f7;">
                            {{ messageSegments }}
                          </td>
                        </tr>
                        <tr>
                          <td style="color:#8392a5;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;padding:7px 0;border-top:1px solid #f0f2f7;">
                            Credits
                          </td>
                          <td style="font-weight:700;color:#0168fa;padding:7px 0;border-top:1px solid #f0f2f7;">
                            {{ totalCredits }} credits
                          </td>
                        </tr>
                        <tr>
                          <td style="color:#8392a5;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;padding:7px 0;border-top:1px solid #f0f2f7;">
                            Send time
                          </td>
                          <td style="font-weight:500;color:#1c273c;padding:7px 0;border-top:1px solid #f0f2f7;">
                            {{ sendTimeDisplay }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="card-footer d-flex align-items-center justify-content-between pd-x-20 pd-y-14"
                       style="background:#f8f9fc;">
                    <button class="btn btn-white btn-sm" @click="goPrev(3)">
                      <i class="fas fa-arrow-left mg-r-6" style="font-size:11px;"></i> Back
                    </button>
                    <button class="btn btn-primary btn-sm" @click="handleSend" :disabled="!canSend">
                      <i class="fas fa-paper-plane mg-r-8" style="font-size:12px;"></i>
                      {{ isSchedule ? 'Schedule Send' : 'Send Now' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- RIGHT: Preview + Credit summary -->
            <div class="col-xl-4 col-lg-5">
              <div class="card" style="position:sticky;top:20px;">
                <!-- Phone preview -->
                <div class="card-header pd-t-15 pd-b-15">
                  <h6 class="card-title tx-13">Message Preview</h6>
                  <div class="card-option tx-12 tx-color-03">{{ senderId || 'AcmeCRM' }}</div>
                </div>
                <div class="card-body pd-x-20 pd-y-16 d-flex justify-content: center;">
                  <div class="phone-preview" style="margin:0 auto;">
                    <div class="phone-notch">
                      <div class="phone-notch-pill"></div>
                    </div>
                    <div class="phone-screen">
                      <div class="phone-sender">{{ senderId || 'AcmeCRM' }}</div>
                      <div class="bubble-wrap">
                        <div class="phone-bubble">
                          <span v-if="!messageBody" class="empty">Your message will appear here…</span>
                          <span v-else>{{ previewMessage }}</span>
                        </div>
                      </div>
                      <div class="phone-time">{{ isSchedule ? (schedDate + ' ' + schedTime) : 'Now' }}</div>
                    </div>
                  </div>
                </div>

                <!-- Credit estimate -->
                <div class="card-footer pd-20" style="background:#f8f9fc;border-top:1px solid #e5e9f2;">
                  <div class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-03 tx-spacing-1 mg-b-10">Credit Estimate
                  </div>
                  <table class="credit-table w-100">
                    <tr>
                      <td class="lbl">Recipients</td>
                      <td class="val">{{ recipients.length }}</td>
                    </tr>
                    <tr>
                      <td class="lbl">Segments / msg</td>
                      <td class="val">{{ messageSegments }}</td>
                    </tr>
                    <tr>
                      <td class="lbl">Credits required</td>
                      <td class="val tx-16" style="color:#0168fa !important;">{{ totalCredits }}</td>
                    </tr>
                    <tr>
                      <td class="lbl">Current balance</td>
                      <td class="val">{{ balance }}</td>
                    </tr>
                    <tr style="border-top:2px solid #e5e9f2;">
                      <td class="lbl tx-semibold">Balance after send</td>
                      <td class="val"
                          :class="{ ok: balanceAfter >= 0, warn: balanceAfter >= 0 && balanceAfter < 50, danger: balanceAfter < 0 }">
                        {{ balanceAfter >= 0 ? balanceAfter : '—' }}
                      </td>
                    </tr>
                  </table>

                  <div class="insuf-notice" :class="{ show: totalCredits > 0 && balanceAfter < 0 }">
                    <i class="fas fa-exclamation-circle" style="flex-shrink:0;font-size:15px;"></i>
                    <div>Need <strong>{{ Math.abs(balanceAfter) }}</strong> more credits.
                      <a href="sms-buy-credits.html" class="tx-semibold"
                         style="color:#b91c1c;text-decoration:underline;margin-left:4px;">Buy →</a>
                    </div>
                  </div>

                  <hr class="mg-y-14">
                  <button class="btn btn-outline-secondary btn-block btn-sm" @click="clearForm">
                    <i class="fas fa-redo mg-r-6" style="font-size:11px;"></i> Reset Form
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Confirm Send Modal - Pure Vue Modal (No jQuery) -->
        <div v-if="modalVisible" class="modal-overlay" @click.self="closeModal">
          <div class="modal-container modal-sm">
            <div class="modal-content">
              <div class="modal-header pd-y-20 pd-x-25">
                <h6 class="tx-14 mg-b-0 tx-semibold">Confirm Send</h6>
                <button type="button" class="close" @click="closeModal"><span>&times;</span></button>
              </div>
              <div class="modal-body pd-25">
                <table class="w-100" style="font-size:13px;">
                  <tr>
                    <td style="color:#596882;padding:5px 0;">Recipients</td>
                    <td style="font-weight:600;text-align:right;">{{ recipients.length }}</td>
                  </tr>
                  <tr>
                    <td style="color:#596882;padding:5px 0;">Segments / msg</td>
                    <td style="font-weight:600;text-align:right;">{{ messageSegments }}</td>
                  </tr>
                  <tr>
                    <td style="color:#596882;padding:5px 0;border-top:1px solid #f4f5f8;">Credits to debit</td>
                    <td style="font-weight:700;text-align:right;color:#0168fa;border-top:1px solid #f4f5f8;">
                      {{ totalCredits }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color:#596882;padding:5px 0;">Balance after</td>
                    <td style="font-weight:600;text-align:right;color:#10b981;">{{
                        balanceAfter >= 0 ? balanceAfter : 0
                      }} credits
                    </td>
                  </tr>
                  <tr>
                    <td style="color:#596882;padding:5px 0;">Send time</td>
                    <td style="font-weight:600;text-align:right;">{{ sendTimeDisplay }}</td>
                  </tr>
                </table>
              </div>
              <div class="modal-footer pd-y-12 pd-x-25">
                <button type="button" class="btn btn-secondary btn-sm" @click="closeModal">Cancel</button>
                <button type="button" class="btn btn-primary btn-sm" @click="confirmSend" :disabled="sending">
                  <span v-if="sending" class="spinner-border spinner-border-sm mg-r-5"></span>
                  <i v-else class="fas fa-paper-plane mg-r-5" style="font-size:11px;"></i>
                  {{ sending ? 'Sending...' : 'Confirm & Send' }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Success Toast -->
        <div v-if="toastVisible" class="toast-notification" :class="{ show: toastVisible }">
          <div class="d-flex align-items-start" style="gap:10px;">
            <div
                style="width:32px;height:32px;border-radius:50%;background:#e6f9f2;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
              <i class="fas fa-check" style="color:#10b981;font-size:13px;"></i>
            </div>
            <div style="flex:1;">
              <div class="tx-semibold tx-14 tx-color-01">Messages queued!</div>
              <div class="tx-13 tx-color-03 mg-t-2">{{ toastMessage }}</div>
            </div>
            <button @click="toastVisible = false"
                    style="background:none;border:none;cursor:pointer;color:#8392a5;font-size:16px;padding:0;line-height:1;">
              &times;
            </button>
          </div>
          <div class="mg-t-10">
            <a href="sms-message-history.html" class="btn btn-sm btn-light" style="font-size:12px;">View in history
              →</a>
          </div>
        </div>
      </div>

    </div><!-- container -->

  </div>
</template>







<script>
import SideBarAsideFix from "../components/SideBarAsideFix.vue";
import footerScriptMixin from "@/mixins/footer-script";

export default {
  name: 'SmsSendMessage',
  components: {SideBarAsideFix},
  mixins: [footerScriptMixin],
  data() {
    return {
      // Balance & Credits
      balance: 450,

      // Recipients
      recipients: [],
      newRecipient: '',
      recipientTab: 'manual',
      crmSelected: new Set(),
      contactSearch: '',

      // Message
      senderId: 'AcmeCRM',
      encoding: 'gsm7',
      messageBody: '',
      mergeDropdownOpen: false,

      // Send Time
      isSchedule: false,
      schedDate: '',
      schedTime: '',
      schedTz: 'Europe/London (GMT+1)',

      // Stepper
      currentStep: 1,
      steps: [
        {num: 1, title: 'Step 1', subtitle: 'Recipients'},
        {num: 2, title: 'Step 2', subtitle: 'Message'},
        {num: 3, title: 'Step 3', subtitle: 'Send Time'}
      ],

      // UI State
      modalVisible: false,
      sending: false,
      toastVisible: false,
      toastMessage: '',
      toastTimeout: null,

      // CRM Data
      crmContacts: [
        {name: 'James Holloway', phone: '+447700900001', initials: 'JH', color: '#0168fa'},
        {name: 'Sarah Mitchell', phone: '+447700900002', initials: 'SM', color: '#10b981'},
        {name: 'Tom Radcliffe', phone: '+447700900003', initials: 'TR', color: '#f59e0b'},
        {name: 'Emily Chen', phone: '+447700900004', initials: 'EC', color: '#8b5cf6'},
        {name: 'David Okafor', phone: '+447700900005', initials: 'DO', color: '#ef4444'},
        {name: 'Laura Simmons', phone: '+447700900006', initials: 'LS', color: '#0ea5e9'},
        {name: 'Kevin Walsh', phone: '+447700900007', initials: 'KW', color: '#f97316'},
        {name: 'Priya Sharma', phone: '+447700900008', initials: 'PS', color: '#ec4899'},
        {name: 'Marcus Brown', phone: '+447700900009', initials: 'MB', color: '#6366f1'},
        {name: 'Zoe Adeyemi', phone: '+447700900010', initials: 'ZA', color: '#14b8a6'}
      ]
    }
  },
  created() {
    this.footerScript();
    this.asideBarScript();
  },
  computed: {
    progressPercent() {
      const map = {1: '33%', 2: '67%', 3: '100%'}
      return map[this.currentStep]
    },
    filteredContacts() {
      if (!this.contactSearch) return this.crmContacts
      const search = this.contactSearch.toLowerCase()
      return this.crmContacts.filter(c =>
          c.name.toLowerCase().includes(search) || c.phone.includes(search)
      )
    },
    messageLength() {
      return this.messageBody.length
    },
    limitGsm7() {
      return 160
    },
    limitMultiGsm7() {
      return 153
    },
    limitUcs2() {
      return 70
    },
    limitMultiUcs2() {
      return 67
    },
    segmentLimit() {
      return this.encoding === 'ucs2' ? this.limitUcs2 : this.limitGsm7
    },
    segmentMulti() {
      return this.encoding === 'ucs2' ? this.limitMultiUcs2 : this.limitMultiGsm7
    },
    messageSegments() {
      const len = this.messageLength
      if (len === 0) return 1
      return len <= this.segmentLimit ? 1 : Math.ceil(len / this.segmentMulti)
    },
    maxCharsPerSegment() {
      if (this.messageSegments === 1) return this.segmentLimit
      return this.messageSegments * this.segmentMulti
    },
    charPercent() {
      return Math.min(100, (this.messageLength / this.segmentLimit) * 100)
    },
    hasUnicode() {
      return ""; // /[^\u0000-\u00ff]/.test(this.messageBody)
    },
    totalCredits() {
      return this.recipients.length * this.messageSegments
    },
    balanceAfter() {
      return this.balance - this.totalCredits
    },
    canSend() {
      return this.recipients.length > 0 && this.messageBody.trim() && this.balanceAfter >= 0
    },
    sendTimeDisplay() {
      if (this.isSchedule && this.schedDate && this.schedTime) {
        return `${this.schedDate} at ${this.schedTime}`
      }
      return 'Immediately after confirmation'
    },
    previewMessage() {
      return this.messageBody
          .replace(/\{\{firstName\}\}/g, 'James')
          .replace(/\{\{lastName\}\}/g, 'Holloway')
          .replace(/\{\{company\}\}/g, 'Acme Ltd')
          .replace(/\{\{appointmentDate\}\}/g, 'Mon 7 Apr')
          .replace(/\{\{bookingRef\}\}/g, 'BK-1042')
    }
  },
  watch: {
    messageBody() {
      this.updateCounts()
    },
    encoding() {
      this.updateCounts()
    },
    recipients: {
      deep: true,
      handler() {
        this.updateCounts()
      }
    }
  },
  mounted() {
    this.addDemoData()

    // Close merge dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
    if (this.toastTimeout) clearTimeout(this.toastTimeout)
  },
  methods: {
    handleClickOutside(event) {
      const mergeBtn = this.$el.querySelector('.merge-btn')
      const mergeDropdown = this.$el.querySelector('.merge-dropdown')
      if (this.mergeDropdownOpen && mergeDropdown && !mergeDropdown.contains(event.target) && !mergeBtn?.contains(event.target)) {
        this.mergeDropdownOpen = false
      }
    },

    addDemoData() {
      setTimeout(() => {
        this.addTag('+447700900001')
        this.addTag('+447700900002')
        this.messageBody = 'Hi {{firstName}}, your appointment is confirmed for 10am tomorrow. Reply STOP to opt out.'
        this.senderId = 'AcmeCRM'
      }, 200)
    },

    updateCounts() {
      // This is handled by computed properties, but kept for compatibility
    },

    // Stepper Methods
    goNext(fromStep) {
      if (fromStep === 1 && this.recipients.length === 0) {
        this.showValidationToast('Add at least one recipient to continue.')
        return
      }
      if (fromStep === 2 && !this.messageBody.trim()) {
        this.showValidationToast('Please write a message body before continuing.')
        return
      }
      this.currentStep = fromStep + 1
      this.$nextTick(() => {
        document.querySelector('.stepper-wrap')?.scrollIntoView({behavior: 'smooth', block: 'nearest'})
      })
    },
    goPrev(fromStep) {
      this.currentStep = fromStep - 1
      this.$nextTick(() => {
        document.querySelector('.stepper-wrap')?.scrollIntoView({behavior: 'smooth', block: 'nearest'})
      })
    },
    jumpTo(stepNum) {
      if (stepNum > this.currentStep + 1 || stepNum === this.currentStep) return
      this.currentStep = stepNum
      this.$nextTick(() => {
        document.querySelector('.stepper-wrap')?.scrollIntoView({behavior: 'smooth', block: 'nearest'})
      })
    },

    // Recipient Methods
    focusRecipientInput() {
      this.$refs.recipientInput?.focus()
    },
    addTag(number) {
      number = number.trim().replace(/,/g, '')
      if (!number) return
      if (!/^\+?[0-9\s\-()]{7,20}$/.test(number)) {
        if (this.$refs.recipientInput) {
          this.$refs.recipientInput.style.color = '#ef4444'
          setTimeout(() => {
            if (this.$refs.recipientInput) this.$refs.recipientInput.style.color = ''
          }, 900)
        }
        this.newRecipient = ''
        return
      }
      if (!this.recipients.includes(number)) {
        this.recipients.push(number)
      }
      this.newRecipient = ''
    },
    removeTag(idx) {
      this.recipients.splice(idx, 1)
    },
    handleTagKey(event) {
      if (event.key === 'Enter' || event.key === ',') {
        event.preventDefault()
        this.addTag(this.newRecipient)
      }
      if (event.key === 'Backspace' && this.newRecipient === '' && this.recipients.length > 0) {
        this.recipients.pop()
      }
    },
    recipientInputHint() {
      if (this.newRecipient.includes(',')) {
        const parts = this.newRecipient.split(',')
        parts.forEach(part => {
          if (part.trim()) this.addTag(part)
        })
        this.newRecipient = ''
      }
    },
    toggleCrmContact(phone) {
      if (this.crmSelected.has(phone)) {
        this.crmSelected.delete(phone)
      } else {
        this.crmSelected.add(phone)
      }
      // Force reactivity for Set
      this.crmSelected = new Set(this.crmSelected)
    },
    addCrmSelected() {
      this.crmContacts.forEach(contact => {
        if (this.crmSelected.has(contact.phone) && !this.recipients.includes(contact.phone)) {
          this.recipients.push(contact.phone)
        }
      })
      this.crmSelected.clear()
      this.recipientTab = 'manual'
      this.contactSearch = ''
    },

    // Merge Tag Methods
    toggleMergeDropdown() {
      this.mergeDropdownOpen = !this.mergeDropdownOpen
    },
    insertMerge(tag) {
      const textarea = this.$refs.messageTextarea
      if (textarea) {
        const start = textarea.selectionStart
        const end = textarea.selectionEnd
        this.messageBody = this.messageBody.substring(0, start) + tag + this.messageBody.substring(end)
        this.$nextTick(() => {
          textarea.selectionStart = start + tag.length
          textarea.selectionEnd = start + tag.length
          textarea.focus()
        })
      }
      this.mergeDropdownOpen = false
    },

    // Send Time Methods
    formatTime(event) {
      const value = event.target.value.replace(/\D/g, '')
      if (value.length >= 3) {
        this.schedTime = value.substring(0, 2) + ':' + value.substring(2, 4)
      }
    },

    // Modal Methods (No jQuery!)
    openModal() {
      this.modalVisible = true
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.modalVisible = false
      document.body.style.overflow = ''
    },

    // Send Methods
    handleSend() {
      if (!this.canSend) return
      this.openModal()
    },
    confirmSend() {
      this.sending = true
      const creditsToDeduct = this.totalCredits

      setTimeout(() => {
        this.balance -= creditsToDeduct
        this.closeModal()
        this.sending = false

        this.toastMessage = `${this.recipients.length} message${this.recipients.length !== 1 ? 's' : ''} queued. New balance: ${this.balance} credits.`
        this.toastVisible = true

        if (this.toastTimeout) clearTimeout(this.toastTimeout)
        this.toastTimeout = setTimeout(() => {
          this.toastVisible = false
        }, 5000)

        this.clearForm()
      }, 1500)
    },

    // Form Methods
    clearForm() {
      this.recipients = []
      this.crmSelected.clear()
      this.messageBody = ''
      this.senderId = 'AcmeCRM'
      this.newRecipient = ''
      this.schedDate = ''
      this.schedTime = ''
      this.isSchedule = false
      this.currentStep = 1
    },

    showValidationToast(message) {
      this.toastMessage = message
      this.toastVisible = true

      // Style as error toast
      const toastEl = this.$el.querySelector('.toast-notification')
      if (toastEl) {
        toastEl.style.borderLeftColor = '#ef4444'
        const icon = toastEl.querySelector('div > i')
        if (icon) {
          icon.className = 'fas fa-exclamation-circle'
          icon.style.color = '#ef4444'
        }
      }

      if (this.toastTimeout) clearTimeout(this.toastTimeout)
      this.toastTimeout = setTimeout(() => {
        this.toastVisible = false
        const toastEl = this.$el.querySelector('.toast-notification')
        if (toastEl) toastEl.style.borderLeftColor = '#10b981'
      }, 3500)
    }
  }
}
</script>

<style scoped>

/* Import styles from original */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');


/* Add these new styles for the pure Vue modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 400px;
}

.modal-sm {
  max-width: 300px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e9f2;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #e5e9f2;
}

.close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #8392a5;
  padding: 0;
  line-height: 1;
}

.close:hover {
  color: #1c273c;
}

.toast-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  min-width: 300px;
  background: #fff;
  border-left: 4px solid #10b981;
  border-radius: 6px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  padding: 14px 18px;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(30px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.sms-send-component {
  background-color: #f4f5f8;
  min-height: 100vh;
}

.content-body {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Stepper styles */
.stepper-wrap {
  background: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 10px;
  margin-bottom: 24px;
  overflow: hidden;
}

.stepper {
  display: flex;
  align-items: stretch;
}

.step-tab {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  position: relative;
  cursor: pointer;
  user-select: none;
  transition: background .15s;
  border-right: 1px solid #e5e9f2;
}

.step-tab:last-child {
  border-right: none;
}

.step-tab:hover:not(.active):not(.disabled) {
  background: #f8f9fc;
}

.step-tab.disabled {
  cursor: not-allowed;
  opacity: .55;
}

.step-tab:not(:last-child)::after {
  content: '';
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 10px solid #fff;
  z-index: 2;
}

.step-tab:not(:last-child)::before {
  content: '';
  position: absolute;
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 12px solid #e5e9f2;
  z-index: 1;
}

.step-tab.active {
  background: #0168fa;
}

.step-tab.active::after {
  border-left-color: #0168fa;
}

.step-tab.active::before {
  border-left-color: #0168fa;
}

.step-tab.done {
  background: #f0fdf9;
}

.step-tab.done::after {
  border-left-color: #f0fdf9;
}

.step-tab.done::before {
  border-left-color: #d1fae5;
}

.step-num {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  background: #e5e9f2;
  color: #8392a5;
  transition: background .2s, color .2s;
}

.step-tab.active .step-num {
  background: rgba(255, 255, 255, .25);
  color: #fff;
}

.step-tab.done .step-num {
  background: #10b981;
  color: #fff;
}

.step-text {
  min-width: 0;
}

.step-title-text {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #8392a5;
  white-space: nowrap;
}

.step-tab.active .step-title-text {
  color: rgba(255, 255, 255, .8);
}

.step-tab.done .step-title-text {
  color: #059669;
}

.step-subtitle {
  font-size: 13px;
  font-weight: 600;
  color: #1c273c;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.step-tab.active .step-subtitle {
  color: #fff;
}

.step-tab.done .step-subtitle {
  color: #065f46;
}

.stepper-progress {
  height: 3px;
  background: #e5e9f2;
}

.stepper-progress-fill {
  height: 100%;
  background: #0168fa;
  transition: width .35s ease;
}

/* Step panels */
.step-panel {
  display: block;
}

.step-panel {
  animation: panelIn .25s ease;
}

@keyframes panelIn {
  from {
    opacity: 0;
    transform: translateX(18px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

/* Recipient box */
.recipient-box {
  min-height: 44px;
  border: 1px solid #e5e9f2;
  border-radius: 5px;
  padding: 6px 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
  background: #fff;
  cursor: text;
  transition: border-color .15s, box-shadow .15s;
}

.recipient-box:focus-within {
  border-color: #0168fa;
  box-shadow: 0 0 0 3px rgba(1, 104, 250, .12);
}

.recipient-box input {
  border: none;
  outline: none;
  font-size: 13px;
  color: #1c273c;
  flex: 1;
  min-width: 140px;
  background: transparent;
  padding: 2px 0;
}

.recipient-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #e8f0fe;
  color: #0168fa;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 20px;
  white-space: nowrap;
}

.recipient-tag .tag-remove {
  cursor: pointer;
  opacity: .6;
  font-size: 11px;
  line-height: 1;
  background: none;
  border: none;
  padding: 0;
  color: #0168fa;
}

.recipient-tag .tag-remove:hover {
  opacity: 1;
}

/* Contact rows */
.contact-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f4f5f8;
  cursor: pointer;
}

.contact-row:last-child {
  border-bottom: none;
}

.contact-row:hover {
  background: #f8f9ff;
  border-radius: 4px;
  padding-left: 4px;
}

.contact-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  color: #fff;
}

/* Message composer */
.msg-area-wrap {
  position: relative;
}

.msg-area-wrap textarea {
  resize: vertical;
  min-height: 130px;
  font-size: 14px;
  line-height: 1.6;
  padding-bottom: 38px;
}

.msg-footer-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 6px 12px;
  background: #f8f9fc;
  border-top: 1px solid #e5e9f2;
  border-radius: 0 0 5px 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
}

.char-meter {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bar-track {
  width: 70px;
  height: 4px;
  background: #e5e9f2;
  border-radius: 2px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 2px;
  background: #0168fa;
  transition: width .1s;
}

.bar-fill.warn {
  background: #f59e0b;
}

.bar-fill.over {
  background: #ef4444;
}

.merge-btn {
  pointer-events: all;
}

.merge-dropdown {
  display: none;
  position: absolute;
  bottom: 42px;
  right: 10px;
  background: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, .1);
  z-index: 50;
  min-width: 180px;
}

.merge-dropdown.open {
  display: block;
}

.merge-head {
  padding: 6px 14px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #8392a5;
  background: #f8f9fc;
  border-bottom: 1px solid #e5e9f2;
}

.merge-item {
  padding: 8px 14px;
  font-size: 13px;
  cursor: pointer;
  color: #1c273c;
}

.merge-item:hover {
  background: #f5f8ff;
  color: #0168fa;
}

/* Segment dots */
.seg-dots {
  display: flex;
  gap: 3px;
  align-items: center;
}

.seg-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e5e9f2;
  transition: background .15s;
}

.seg-dot.active {
  background: #0168fa;
}

/* Phone preview */
.phone-preview {
  width: 210px;
  border: 8px solid #1c273c;
  border-radius: 28px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, .15);
  flex-shrink: 0;
}

.phone-notch {
  background: #1c273c;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-notch-pill {
  width: 56px;
  height: 7px;
  background: #2d3e52;
  border-radius: 4px;
}

.phone-screen {
  background: #f0f0f0;
  min-height: 260px;
  padding: 10px 8px;
}

.phone-sender {
  text-align: center;
  font-size: 11px;
  color: #8392a5;
  margin-bottom: 10px;
}

.bubble-wrap {
  display: flex;
  justify-content: flex-start;
}

.phone-bubble {
  background: #e5e5ea;
  color: #1c273c;
  border-radius: 16px 16px 16px 4px;
  padding: 9px 12px;
  font-size: 12px;
  line-height: 1.55;
  max-width: 178px;
  word-break: break-word;
}

.phone-bubble .empty {
  color: #aab0bc;
  font-style: italic;
}

.phone-time {
  font-size: 10px;
  color: #8392a5;
  margin-top: 5px;
  padding-left: 6px;
}

/* Credit table */
.credit-table td {
  font-size: 13px;
  padding: 7px 0;
  border-top: 1px solid #f4f5f8;
  vertical-align: middle;
}

.credit-table tr:first-child td {
  border-top: none;
}

.credit-table .lbl {
  color: #596882;
}

.credit-table .val {
  font-weight: 600;
  color: #1c273c;
  text-align: right;
}

.credit-table .val.ok {
  color: #10b981;
}

.credit-table .val.warn {
  color: #f59e0b;
}

.credit-table .val.danger {
  color: #ef4444;
}

/* Credit warning */
.credit-warning {
  display: none;
  align-items: center;
  gap: 10px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #92400e;
}

.credit-warning.show {
  display: flex;
}

/* Insufficient notice */
.insuf-notice {
  display: none;
  align-items: center;
  gap: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 9px 12px;
  font-size: 12px;
  color: #b91c1c;
  margin-top: 10px;
}

.insuf-notice.show {
  display: flex;
}

/* Tabs */
.send-mode-tabs .nav-link,
.recip-tabs .nav-link {
  font-size: 13px;
  font-weight: 500;
  padding: 8px 18px;
  color: #596882;
  border-radius: 5px 5px 0 0;
}

.send-mode-tabs .nav-link.active,
.recip-tabs .nav-link.active {
  color: #0168fa;
  background: #fff;
  border: 1px solid #e5e9f2;
  border-bottom-color: #fff;
}

/* Success toast */
#successToast {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  min-width: 300px;
  background: #fff;
  border-left: 4px solid #10b981;
  border-radius: 6px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, .12);
  padding: 14px 18px;
  animation: slideIn .3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(30px);
    opacity: 0;
  }
  to {
    transform: none;
    opacity: 1;
  }
}

/* Responsive */
@media (max-width: 575px) {
  .step-subtitle {
    display: none;
  }

  .step-tab {
    padding: 14px 10px;
    gap: 8px;
  }
}

/* Utility classes from DashForge */
.wd-32 {
  width: 32px;
}

.rounded-circle {
  border-radius: 50%;
}

.tx-10 {
  font-size: 10px;
}

.tx-11 {
  font-size: 11px;
}

.tx-12 {
  font-size: 12px;
}

.tx-13 {
  font-size: 13px;
}

.tx-14 {
  font-size: 14px;
}

.tx-16 {
  font-size: 16px;
}

.tx-semibold {
  font-weight: 600;
}

.tx-bold {
  font-weight: 700;
}

.tx-uppercase {
  text-transform: uppercase;
}

.tx-spacing-1 {
  letter-spacing: .05em;
}

.tx-color-01 {
  color: #1c273c;
}

.tx-color-03 {
  color: #8392a5;
}

.tx-color-04 {
  color: #aab0bc;
}

.mg-b-0 {
  margin-bottom: 0;
}

.mg-b-5 {
  margin-bottom: 5px;
}

.mg-b-10 {
  margin-bottom: 10px;
}

.mg-b-12 {
  margin-bottom: 12px;
}

.mg-b-15 {
  margin-bottom: 15px;
}

.mg-b-16 {
  margin-bottom: 16px;
}

.mg-b-20 {
  margin-bottom: 20px;
}

.mg-b-25 {
  margin-bottom: 25px;
}

.mg-r-4 {
  margin-right: 4px;
}

.mg-r-5 {
  margin-right: 5px;
}

.mg-r-6 {
  margin-right: 6px;
}

.mg-r-8 {
  margin-right: 8px;
}

.mg-r-10 {
  margin-right: 10px;
}

.mg-l-5 {
  margin-left: 5px;
}

.mg-l-6 {
  margin-left: 6px;
}

.mg-t-2 {
  margin-top: 2px;
}

.mg-t-4 {
  margin-top: 4px;
}

.mg-t-6 {
  margin-top: 6px;
}

.mg-t-10 {
  margin-top: 10px;
}

.mg-t-20 {
  margin-top: 20px;
}

.pd-20 {
  padding: 20px;
}

.pd-x-12 {
  padding-left: 12px;
  padding-right: 12px;
}

.pd-x-20 {
  padding-left: 20px;
  padding-right: 20px;
}

.pd-x-25 {
  padding-left: 25px;
  padding-right: 25px;
}

.pd-y-6 {
  padding-top: 6px;
  padding-bottom: 6px;
}

.pd-y-9 {
  padding-top: 9px;
  padding-bottom: 9px;
}

.pd-y-10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.pd-y-12 {
  padding-top: 12px;
  padding-bottom: 12px;
}

.pd-y-14 {
  padding-top: 14px;
  padding-bottom: 14px;
}

.pd-y-16 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.pd-y-20 {
  padding-top: 20px;
  padding-bottom: 20;
}
</style>
